export function editCoachPoolReducer(state, action) {
  const merge = require("deepmerge");

  switch (action.type) {
    case "loadCoaches":
      return {
        ...state,
        coaches: action.coaches,
      };
    case "updateCoachPoolName":
      return {
        ...state,
        coachPool: merge(state.coachPool, {
          attributes: { name: action.name },
        }),
        formCanged: true,
      };
    case "updateCoachPoolDefault":
      return {
        ...state,
        coachPool: merge(state.coachPool, {
          attributes: { default: action.default },
        }),
        formCanged: true,
      };
    case "updateCoachPoolSelectedCoach":
      return {
        ...state,
        coachSelected: action.status
          ? [...state.coachSelected, action.coachId]
          : [...state.coachSelected].filter((n) => n != action.coachId),
        allRecordSelected: state.allRecordSelected && action.status,
        formCanged: true,
      };
    case "selectAllRecords":
      return {
        ...state,
        allRecordSelected: action.status,
        coachSelected: action.status
          ? state.coaches.map((coach) => coach.id)
          : [],
        formCanged: true,
      };
    case "successUpdateCoachPool":
      return {
        ...state,
        coachPoolNameError: "",
        formCanged: false,
      };
    case "errorUpdateCoachPool":
      return {
        ...state,
        coachPoolNameError: action.errors,
      };

    case "selectAllFilteredRecords":
      return {
        ...state,
        allRecordSelected: action.status,
        coachSelected: action.status
          ? [...state.coachSelected, ...action.recordIds].filter(
              (v, i, a) => a.indexOf(v) === i
            )
          : state.coachSelected.filter(
              (item) => !action.recordIds.includes(item)
            ),
        formCanged: true,
      };
    case "clearSelectedAll":
      return {
        ...state,
        allRecordSelected: false,
      };

    default:
      throw new Error();
  }
}
